/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NormalOrderCheckInfoOrderCheckGoodsVo } from './NormalOrderCheckInfoOrderCheckGoodsVo';
import {
    NormalOrderCheckInfoOrderCheckGoodsVoFromJSON,
    NormalOrderCheckInfoOrderCheckGoodsVoFromJSONTyped,
    NormalOrderCheckInfoOrderCheckGoodsVoToJSON,
    NormalOrderCheckInfoOrderCheckGoodsVoToJSONTyped,
} from './NormalOrderCheckInfoOrderCheckGoodsVo';

/**
 * 
 * @export
 * @interface NormalOrderCheckInfoVo
 */
export interface NormalOrderCheckInfoVo {
    /**
     * 订单编号
     * @type {string}
     * @memberof NormalOrderCheckInfoVo
     */
    orderCode?: string;
    /**
     * 仓库名称
     * @type {string}
     * @memberof NormalOrderCheckInfoVo
     */
    warehouseName?: string;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof NormalOrderCheckInfoVo
     */
    orderStatusName?: string;
    /**
     * 请求分组
     * @type {string}
     * @memberof NormalOrderCheckInfoVo
     */
    requestGroup?: string;
    /**
     * 请求类型
     * @type {string}
     * @memberof NormalOrderCheckInfoVo
     */
    requestType?: string;
    /**
     * 商品检查单列表
     * @type {Array<NormalOrderCheckInfoOrderCheckGoodsVo>}
     * @memberof NormalOrderCheckInfoVo
     */
    orderCheckGoods?: Array<NormalOrderCheckInfoOrderCheckGoodsVo>;
}

/**
 * Check if a given object implements the NormalOrderCheckInfoVo interface.
 */
export function instanceOfNormalOrderCheckInfoVo(value: object): value is NormalOrderCheckInfoVo {
    return true;
}

export function NormalOrderCheckInfoVoFromJSON(json: any): NormalOrderCheckInfoVo {
    return NormalOrderCheckInfoVoFromJSONTyped(json, false);
}

export function NormalOrderCheckInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NormalOrderCheckInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'orderCheckGoods': json['orderCheckGoods'] == null ? undefined : ((json['orderCheckGoods'] as Array<any>).map(NormalOrderCheckInfoOrderCheckGoodsVoFromJSON)),
    };
}

export function NormalOrderCheckInfoVoToJSON(json: any): NormalOrderCheckInfoVo {
    return NormalOrderCheckInfoVoToJSONTyped(json, false);
}

export function NormalOrderCheckInfoVoToJSONTyped(value?: NormalOrderCheckInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'warehouseName': value['warehouseName'],
        'orderStatusName': value['orderStatusName'],
        'requestGroup': value['requestGroup'],
        'requestType': value['requestType'],
        'orderCheckGoods': value['orderCheckGoods'] == null ? undefined : ((value['orderCheckGoods'] as Array<any>).map(NormalOrderCheckInfoOrderCheckGoodsVoToJSON)),
    };
}

